import axios from "axios";
import http from "./http";

const configService = {
	async auth(password: string) {
		return http.post("/api/kft-com/metaphor/auth", {
			password
		});
	},

	async isAuthEnabled(): Promise<boolean> {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await http.get(
					"/api/kft-com/metaphor/is-auth-enabled"
				);
				if (resp.data.data) {
					return resolve(true);
				} else {
					return resolve(false);
				}
			} catch (error) {
				return resolve(false);
			}
		});
	}
};

export default configService;
